import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import TioFooter from 'tio-common/components/tio/footer';
import Button from 'tio-reimagined/components/button';
import { on } from '@ember/modifier';
import transitionTo from 'ember-router-helpers/helpers/transition-to';

<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <main class="flex flex-col items-center justify-center flex-grow px-4 py-10">
      <section class="w-full max-w-screen-sm bg-white shadow-md rounded-md p-8 text-center">
        <p class="mb-3 text-lg font-semibold">{{t "logged_out.thank_you"}}</p>
        <p class="mb-6 text-gray-500">{{t "logged_out.success"}}</p>
        <Button {{on "click" (transitionTo "login")}} @intent="primary" class="w-full sm:w-auto">
          {{t "logged_out.sign_in_button"}}
        </Button>
      </section>

      <div class="mt-10 max-w-md w-full flex justify-center">
        {{svgJar "growth" role="img" desc=(t "svg.growth") class="w-full h-auto"}}
      </div>
    </main>
    <TioFooter />
  </div>
</template>
